import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4c8713da&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Header.vue?vue&type=style&index=1&id=4c8713da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8713da",
  null
  
)

export default component.exports